import { render, staticRenderFns } from "./ResultDialog.vue?vue&type=template&id=98d01e46&scoped=true"
import script from "./ResultDialog.vue?vue&type=script&lang=js"
export * from "./ResultDialog.vue?vue&type=script&lang=js"
import style0 from "./ResultDialog.vue?vue&type=style&index=0&id=98d01e46&prod&lang=css"
import style1 from "./ResultDialog.vue?vue&type=style&index=1&id=98d01e46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d01e46",
  null
  
)

export default component.exports